<div class="list-container" ngClass.lt-md="mobile">
  <div
    *ngFor="
      let item of list | slice: getPageLowerLimit():getPageUpperLimit();
      trackBy: trackByFn
    "
  >
    <div
      class="item"
      fxLayout.lt-md="column"
      fxLayout.gt-sm="row"
      fxLayoutGap="8px"
      fxLayoutAlign.gt-sm="space-between center"
      tabindex="0"
      appGtm
      [gtmOnClick]="true"
      [gtmData]="{
        event: 'gtm.episodes.homepage.view_carepath',
        episodes_procedure_name: item.episode_name
      }"
      (click)="handleSelect(item.primary_procedure_id)"
    >
      <div fxFlex="60%">
        <div class="name link-blue">{{ item.episode_name }}</div>
        <div
          class="description text-small margin top-1x bottom-1x"
          *ngIf="item.primary_procedure_description"
        >
          {{ item.primary_procedure_description }}
        </div>
      </div>
      <div
        class="text-center"
        fxFlexOrder.lt-md="2"
        fxFlexOrder.gt-sm="1"
        fxFlex
      >
        <zelis-button
          variant="stroked"
          ngClass.gt-sm="button-active hover-button"
          ngClass.lt-md="button-full"
          color="accent"
        >
          {{ 'app_global_view_carepath' | translate }}
        </zelis-button>
      </div>
      <div
        class="procedure-steps"
        fxFlex="nogrow"
        fxFlexOrder.lt-md="1"
        fxFlexOrder.gt-sm="2"
      >
        <div
          fxLayout.gt-sm="column"
          fxLayout.lt-md="row"
          fxLayoutAlign.gt-sm="center end"
          fxLayoutAlign.lt-md="start"
        >
          <div>
            {{ 'eoc_procedure_steps' | translate }}<span class="colon">:</span>
          </div>
          <div class="step-count">{{ item.components.length }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div fxLayout class="pad top-4x bottom-5x">
  <zelis-button
    variant="flat"
    class="view-all-carepaths"
    color="accent"
    fxFlex="none"
    fxFlex.sm="100%"
    fxFlex.xs="100%"
    [ariaLabel]="getButtonText() | translate"
    appGtm
    [gtmOnClick]="true"
    [gtmData]="{ event: 'gtm.episodes.homepage.see_all_carepaths' }"
    (clickFn)="toggleExpand()"
  >
    <span>{{ getButtonText() | translate }}</span>
  </zelis-button>
</div>

<zelis-pagination
  *ngIf="expanded && list?.length > limit"
  [page]="page"
  [length]="list.length"
  [pageSize]="limit"
  [showNextPrev]="true"
  [showStats]="true"
  [showPageJump]="true"
  [translations]="{
    previous: 'app_global_pagination_previous' | translate,
    next: 'app_global_pagination_next' | translate,
    of: 'app_global_pagination_of' | translate,
    page: 'app_global_pagination_page' | translate,
    jumpToPage: 'app_global_pagination_jump' | translate
  }"
  (change)="handlePagination($event)"
>
</zelis-pagination>
